import React from "react";
import PropTypes from "prop-types";
import { Flex, Button } from "@sainsburys-tech/fable";
import { Close } from '@sainsburys-tech/icons'
const Toast = ({ details, onClose }) => (
  <div className="cb-c-toast-list__toast">
    <div
      className={
        "fable:text-white fable:p-4 fable:mt-8 " +
        (details.status === "danger"
          ? "fable:bg-red-600"
          : "fable:bg-gray-700")
      }
    >
      <Flex gap="md" alignItems="flex-start">
        <div style={{ flex: 1 }}>
          <Flex gap="md" alignItems="flex-start">
            <div style={{ flex: 1 }}>
              <h5 className="fable:mb-2">{details.headerText}</h5>
              {details.bodyText}
            </div>
            <div style={{ flexShrink: 0 }}>
              <Button
                variant="ghost"
                size="sm"
                onClick={onClose}
                title="Close"
              >
                <Close />
                <span className="fable:sr-only">Close</span>
              </Button>
            </div>
          </Flex>
        </div>
      </Flex>
    </div>
  </div>
);

Toast.propTypes = {
  details: PropTypes.shape({
    status: PropTypes.string.isRequired,
    headerText: PropTypes.string.isRequired,
    bodyText: PropTypes.string.isRequired
  }).isRequired,
  onClose: PropTypes.func.isRequired
};

export default Toast;
